import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo recibo el Ciencias 360 después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. También podés acceder desde tu cuenta de Shopify. Todo en PDF, descarga directa, sin aplicaciones extra.'
  }, {
    q: '¿Sirve para mi provincia?',
    a: 'Sí. El contenido está alineado al currículo nacional argentino de Ciencias Naturales para secundaria. Aplica en todas las provincias porque trabaja los núcleos de aprendizaje prioritarios (NAP) y los diseños curriculares jurisdiccionales de las principales provincias.'
  }, {
    q: '¿Está en blanco y negro?',
    a: 'Sí, el diseño de los 12 tomos está optimizado para fotocopiadora en blanco y negro. Los PDF tienen alto contraste para que la impresión quede clara y legible sin gastar tinta de color.'
  }, {
    q: '¿Los 6 bonus están en todas las ofertas?',
    a: 'Sí. Los 6 bonus estratégicos están incluidos en el pack de Físico-Química ($18.990) y en el Megapack Completo ($27.990). No importa cuál elijas, los bonus siempre van.'
  }, {
    q: '¿Puedo comprar el pack de Físico-Química ahora y el Megapack después?',
    a: 'Sí, pero te conviene ir directo al Megapack Completo ($27.990): incluye los 12 tomos (Física, Química y Físico-Química) más los 2 Ebooks Elite. Si después querés sumar el resto, no hay un upgrade automático.'
  }, {
    q: '¿Los Ebooks Elite están en todas las ofertas?',
    a: 'No. Los 2 Ebooks Elite (Tareas Modernas Multimedia y Proyectos Transversales ESI/EAI) son exclusivos del Megapack Completo ($27.990). No están disponibles en el pack individual.'
  }, {
    q: '¿Está actualizado al currículo vigente?',
    a: 'Sí. Los 12 tomos están diseñados en base a los contenidos curriculares del nivel secundario vigentes en Argentina, contemplando los diseños curriculares de las principales jurisdicciones.'
  }, {
    q: '¿Qué pasa si no tengo internet en la escuela?',
    a: 'No hay problema. Los PDF se descargan una sola vez y los tenés para siempre en tu dispositivo. En el aula trabajás con las hojas impresas, sin necesitar conexión.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí, y es real. Si en 7 días no estás conforme, te devolvemos el 100% del dinero. Sin formularios, sin excusas, sin drama. Escribís al soporte y listo.'
  }, {
    q: '¿Qué diferencia tiene con otros packs que vi en internet?',
    a: 'Ciencias 360 es el único sistema diseñado específicamente para docentes de Física, Química y Físico-Química de secundaria en Argentina. No es material genérico: cada tomo está organizado por nivel, con solucionario, secuencia didáctica y optimizado para imprimir. Además incluye los 6 bonus de gestión y, en el Megapack, los proyectos de ESI y EAI ya redactados para presentar a Dirección.'
  }];
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-48">
      <div className="max-w-3xl mx-auto" data-id="element-49">
        <h2 className="text-2xl md:text-3xl font-bold text-carbon text-center mb-10" data-id="element-50">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 transition-colors" data-id="element-53">
                <span className="font-semibold text-carbon pr-4" data-id="element-54">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-sci-orange flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>
              {openIndex === i && <div className="px-4 pb-4 text-gray-700 text-sm leading-relaxed" data-id="element-56">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}